import { Routes } from '@angular/router';
import { AuthorizationGuard } from '@guards/authorization.guard';
import { wrapperRoutes } from '@pages/wrapper/wrapper.routes';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('@pages/wrapper/wrapper.component')
      .then((m) => m.WrapperComponent),
    children: wrapperRoutes,
  },
  {
    path: 'authorization',
    loadComponent: () => import('@pages/authorization/authorization.component')
      .then((m) => m.AuthorizationComponent),
  },
  {
    path: 'admin',
    canActivate: [AuthorizationGuard],
    loadChildren: () => import('@pages/admin/admin.module')
      .then((m) => m.AdminModule),
  },
  {
    path: '**',
    redirectTo: '/not-found',
    pathMatch: 'full',
  },
];
